import React from "react";
import { Link } from "react-router-dom";
import backimg from "../../assets/service-images/packimg-platformatomation.webp";
import image from "../../assets/home-images/Group3.svg";
import image1 from "../../assets/service-images/platformautomation-logo-1.svg";
import image2 from "../../assets/service-images/platformautomation-logo-2.svg";
import image3 from "../../assets/service-images/platformautomation-logo-3.svg";
import image4 from "../../assets/service-images/platformautomation-logo-4.svg";
import image5 from "../../assets/service-images/platformautomation-logo-5.svg";

const PlatformAutomation = () => {
  return (
    <>
      {/* Section 1 */}
      <div
        className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-start px-6 py-16 md:px-8 lg:px-16"
        style={{ backgroundImage: `url(${backimg})` }}
      >
        <h1
          data-aos="fade-down"
          className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-white w-full md:w-2/3 lg:w-1/2"
        >
          Automate Manual Tasks
        </h1>
        <p
          data-aos="fade-down"
          className="text-white text-sm w-full md:w-2/3 lg:w-[500px] xl:w-[500px]"
        >
          Our automation experts design and build custom processes for your
          business, leveraging a rapid 30-day delivery cycle to accelerate your
          return on investment and help you quickly address your automation
          backlog.{" "}
        </p>
        <Link
          data-aos="zoom-in"
          data-aos-delay="300"
          to="/contact-us"
          className="w-[100px] sm:w-[120px] md:w-[140px] lg:w-[160px] bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-7 lg:py-2 rounded-lg text-white font-semibold hover:bg-white hover:text-[#C32A7C] transition-colors duration-300 text-xs sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap"
        >
          Contact Us
        </Link>
      </div>

      {/* Section 2 */}

      <div className="bg-[#FFFFFF] mt-10">
        <div className="flex flex-col sm:justify-center text-center items-center gap-4 py-8 px-4">
          <h1
            className="text-[#1A5298] font-bold text-lg md:text-3xl"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Achieve More When You Automate
          </h1>
        </div>

        <div className="bg-white">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 px-4 md:px-10 lg:px-20 py-5">
            <div
              data-aos="fade-up"
              data-aos-delay="500"
              className=" p-6 flex flex-col items-center w-2/1 text-center justify-center"
            >
              <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold max-w-[230px] text-center">
                Get the Most Out of Your ServiceNow Solutions
              </h2>
              <div className="mt-2 flex flex-col items-center md:w-40 ">
                <img
                  className="object-contain"
                  src={image}
                  alt="Enhance IT Workflows"
                />
              </div>
            </div>

            <div
              data-aos="fade-up"
              data-aos-delay="500"
              className=" p-6 flex flex-col items-center w-2/1 text-center justify-center"
            >
              <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold max-w-[253px] text-center">
                Enhance Operational Agility for Improved Business Performance
              </h2>
              <div className="mt-2 flex flex-col items-center md:w-40 ">
                <img
                  className="object-contain"
                  src={image}
                  alt="Enhance IT Workflows"
                />
              </div>
            </div>
            <div
              data-aos="fade-up"
              data-aos-delay="500"
              className="p-6 flex flex-col items-center justify-center w-2/1 text-center justify-center"
            >
              <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold max-w-[230px] text-center">
                Bridge the Gap Between Disparate Systems
              </h2>
              <div className="mt-2 flex flex-col items-center md:w-40 ">
                <img
                  className="object-contain"
                  src={image}
                  alt="Enhance IT Workflows"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 3 */}

      <div className="flex flex-col justify-start px-4 py-8 md:py-12 lg:py-16 bg-[#F0FAFF]">
        <div className="text-center mb-10 px-6">
          <h1
            className="text-black font-semibold text-3xl"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Our Approach to Implementation
          </h1>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 px-4 md:px-8">
          {[image1, image2, image3].map((img, index) => (
            <div
              data-aos="fade-up"
              data-aos-delay="500"
              key={index}
              className="flex flex-col items-center text-center h-full"
            >
              <div className="w-full bg-gradient-to-r from-[#981A59] to-[#124B6A] h-[10px] mt-20"></div>

              <div className=" sec3 flex flex-col items-center rounded border bg-[#FFFFFF] w-full p-6 h-full justify-between shadow-lg">
                <img className="-mt-16 object-contain" src={img} alt="Step" />
                <p className="text-sm text-black mt-2 flex-grow mb-5">
                  {index === 0
                    ? "We work closely with you to understand your unique business requirements and recommend the most appropriate ServiceNow solutions."
                    : index === 1
                    ? "Our customized ServiceNow implementation plan, informed by the discovery phase, guarantees your ServiceNow instance will meet your organization's specific needs."
                    : "Once the design is approved, our certified Salesforce developers leverage their expertise to build and configure your solution, ensuring it meets your needs and integrates seamlessly with existing systems."}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 px-8 ">
          {[image4, image5].map((img, index) => (
            <div
              data-aos="fade-up"
              data-aos-delay="500"
              key={index}
              className="flex flex-col items-center text-center h-full"
            >
              <div className="w-full bg-gradient-to-r from-[#981A59] to-[#124B6A] h-[10px] mt-20"></div>
              <div className="flex flex-col items-center rounded border bg-[#FFFFFF] w-full p-6 h-full justify-between shadow-lg sec3">
                <img className="-mt-16 object-contain" src={img} alt="Step" />
                <p className="text-sm text-black mt-2 flex-grow w-full mb-5 sm:max-w-md md:max-w-lg lg:max-w-xl">
                  {index === 0
                    ? "Our comprehensive testing, using diverse scenarios, ensures your ServiceNow implementation functions flawlessly and aligns perfectly with your unique business needs, guaranteeing reliability and resilience."
                    : "We ensure a smooth transition to production for your ServiceNow solution, deploying it with meticulous attention to detail after confirming its stability and guaranteeing flawless functionality with minimal disruption."}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Section 4  */}

      <div className="bg-[#FFFFFF] w-full py-8 md:py-16 mt-6">
        <div
          className="flex flex-col items-center text-center px-4 md:px-6"
          data-aos="fade-down-right"
        >
          <h1 className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 w-full md:w-2/3 lg:w-2/3 xl:w-2/3">
            Get ready for digital transformation!
          </h1>
          <Link
            data-aos="zoom-in"
            data-aos-delay="300"
            to={"/contact-us"}
            className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-bold 
                                                     hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base 
                                                     text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
          >
            Contact us
          </Link>
        </div>
      </div>
    </>
  );
};

export default PlatformAutomation;
